<div [class.skeleton]="loading" [formGroup]="form">
  <ng-container *ngIf="!loading && attributeOptions$ | async as attributeOptions">
    <span class="mb-1 d-block">{{ attribute.name }}</span>
    <py-dropdown
      formControlName="value"
      [resetable]="resetable"
      (resetValue)="resetValue.emit()"
      [placeholder]="'product.select_action_placeholder' | cxTranslate"
      [options]="attributeOptions"
      [title]="attribute.name"
      [badge]="autoSelected ? ('product.autoSelectedAttributeValue_badge' | cxTranslate) : undefined"
      [badgeTooltip]="autoSelected ? ('product.autoSelectedAttributeValue_tooltip' | cxTranslate) : undefined"
    ></py-dropdown>
  </ng-container>
</div>
